import { Directive, ElementRef, EventEmitter, Input, Output, Type } from "@angular/core";
import { FloatUIService } from "../services/floatui.service";
import { Placement } from "@floating-ui/dom";
import { Observable } from "rxjs";
import { EventData } from "../model/floatui-element.model";

@Directive({
  selector: '[floatuiHost]',
  standalone: false,
})
export class FloatUIHostDirective {

    @Input('float-type') componentType!: Type<any>;
    @Input('float-direction') placement?: Placement;
    @Input('float-input') input?: Record<string, unknown>

    @Output('float-output') floatOutput = new EventEmitter<EventData>();

    private id?: string;
    @Input('float-show') set show(show: boolean) {
        if (show) {
            this.id = this.floatUIService.addComponent(this.componentType, this.elementRef.nativeElement, {
                placement: this.placement ?? 'bottom',
                eventSubscriber: (observable: Observable<EventData>) => observable.subscribe(event => this.floatOutput.emit(event)),
                inputs: this.input
            });
        } else if (this.id != undefined) {
            this.floatUIService.removeComponent(this.id);
            this.id = undefined;
        }
    }

    constructor(
        private elementRef: ElementRef,
        private floatUIService: FloatUIService,
    ) {}

}